// extracted by mini-css-extract-plugin
export default {"profileView":"ProfileView_profileView__gfzsx"};